import { useRef } from "react";
import NumberTicker from "components/NumberTicker/NumberTicker";
import useIntroBoxAnimations from "./useIntroBoxAnimations";
import { IntroBoxInt } from "interfaces";
import styles from "./IntroBox.module.scss";

const IntroBox = ({
  primary,
  secondary,
  sub,
  target,
  targetTwo,
  unit,
  space,
}: IntroBoxInt) => {
  const ref = useRef(null);
  useIntroBoxAnimations(ref, target, targetTwo);

  return (
    <section ref={ref} className={styles["intro-box"]}>
      <div className={`${styles["number-ticker"]} anim-ticker-container`}>
        <NumberTicker
          id="anim-intro-box_percent"
          initial={Array(target.length).fill(0)}
        />
        {targetTwo && (
          <>
            <h4 className={`${styles["ticker-unit"]} bold ticker anim-dash`}>
              -
            </h4>
            <NumberTicker
              id="anim-intro-box_percent_two"
              initial={Array(targetTwo.length).fill(0)}
            />
          </>
        )}
        <h4
          className={`${styles["ticker-unit"]} ${
            space ? styles.right : ""
          } bold ticker anim-unit`}
        >
          {unit}
        </h4>
      </div>
      {primary}
      <p className={styles.sub + " anim-sub"}>{sub}</p>
      <div className="anim-wrapper">
        <h4 className={styles.secondary + " anim-secondary bold"}>
          {secondary}
        </h4>
      </div>
    </section>
  );
};

export default IntroBox;
